import { render } from "./feesBarChart.vue?vue&type=template&id=c1a70bf0"
import script from "./feesBarChart.vue?vue&type=script&lang=js"
export * from "./feesBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__